import React, { useState } from "react";
import { Row, Col, Button, Divider } from "antd";
import styles from "./GroceryShopping.module.scss";
import {
  groceryBuyImg,
  groceryListIcon1,
  groceryListIcon2,
  groceryListIcon3,
  groceryListIcon4,
  groceryListIcon5,
  groceryListIcon6,
  groceryListIcon7,
  groceryOrderImg,
  groceryStartShopping,
} from "../../../assets/images";
import { Spinner } from "@mtm/components";
import { useDashboardCtx } from "../../../context/DashboardContext";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { useTripsCtx } from "../../../context/TripDetailsContext";
import { useParams } from "react-router";
type Props = {
  setIsGroceryItemsMobileView: Function;
};

function GroceryShopping({ setIsGroceryItemsMobileView }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { personId } = useParams<{ personId: string }>();
  const { serviceDataCtx } = useTripsCtx();
  const [serviceData] = serviceDataCtx;
  const selectedServiceUser = serviceData.find(
    (person: { firstName: string; lastName: string; personId: number }) =>
      person.personId === parseInt(personId)
  );
  const selectedServiceUserName = `${selectedServiceUser?.firstName} ${selectedServiceUser?.lastName}`;

  const { width } = useWindowSize();

  const handlePageChange = () => {
    width <= 992 && setIsGroceryItemsMobileView(true);
  };

  const images = [
    groceryListIcon1,
    groceryListIcon2,
    groceryListIcon3,
    groceryListIcon4,
    groceryListIcon5,
    groceryListIcon6,
    groceryListIcon7,
  ];

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className={styles.groceryStartShoppingRightContainer}>
          <Row className={styles.groceryBuyItContainer}>
            <Col className={styles.userNameStyle}>
              {selectedServiceUserName}
            </Col>
          </Row>
          <Row>
            <Col className={styles.groceryShoppingCard}>
              <Row>
                <Col span={24}>
                  <img
                    src={groceryStartShopping}
                    alt="Grocery items"
                    className={styles.groceryShoppingImage}
                  />
                </Col>
              </Row>
              <Row className={styles.groceryShoppingContent}>
                <Col
                  xs={24}
                  lg={0}
                  span={24}
                  className={styles.startShoppingStyle}
                >
                  <Button
                    onClick={handlePageChange}
                    className={styles.startShoppingBtnStyle}
                  >
                    Start shopping
                  </Button>
                </Col>

                <Col
                  xs={0}
                  lg={24}
                  span={24}
                  className={styles.startShoppingStyle}
                >
                  Start shopping
                </Col>

                <Col span={24} className={styles.addItemStyle}>
                  Add items to a cart.
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className={styles.groceryBuyItCardContainer}>
            <Col span={12}>
              <Col className={styles.groceryBuyItCard}>
                <Row>
                  <Col span={24}>
                    <img
                      src={groceryBuyImg}
                      alt="Grocery items"
                      className={styles.groceryBuyItImg}
                    />
                  </Col>
                </Row>
                <Row className={styles.groceryShoppingContent}>
                  <Col span={24} className={styles.buyAgainTextStyle}>
                    Buy it again
                  </Col>
                  <Col span={24} className={styles.buyAgainSubTextStyle}>
                    See all items recently purchased.
                  </Col>
                </Row>
              </Col>
            </Col>
            <Col span={12}>
              <Col className={styles.groceryOrdersCard}>
                <Row>
                  <Col span={24}>
                    <img
                      src={groceryOrderImg}
                      alt="Grocery items"
                      className={styles.groceryBuyItImg}
                    />
                  </Col>
                </Row>
                <Row className={styles.groceryShoppingContent}>
                  <Col span={24} className={styles.buyAgainTextStyle}>
                    Orders
                  </Col>
                  <Col span={24} className={styles.addItemStyle}>
                    View favorite and past orders.
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>

          <Divider className={styles.dashedDivider} dashed />

          <Row className={styles.upcomingTextContainerStyle}>
            <Col>Upcoming</Col>
          </Row>

          <Row>
            <Col className={styles.groUpComingCard}>
              <Col className={styles.groupUpComingCardStyle}>
                <Row>
                  <Col span={24} className={styles.groUpComingHeader}>
                    <p className={styles.groUpComingDeliveryDate}>
                      Delivery: May 12, 2024
                    </p>
                    <p className={styles.groUpComingItems}>24 items</p>
                  </Col>
                </Row>
                <Row className={styles.groUpComingImagesRow}>
                  <Col span={24} className={styles.groUpComingImagesCol}>
                    {images.map((imageSrc, index) => (
                      <img
                        key={index}
                        src={imageSrc}
                        alt={`groceryListIcon${index + 1}`}
                        className={styles.groUpComingImage}
                      />
                    ))}
                  </Col>
                </Row>
              </Col>
              <Row className={styles.groUpComingButtonsRow}>
                <Col span={12}>
                  <Button className={styles.groUpComingButton}>
                    Add all to cart
                  </Button>
                </Col>
                <Col span={12}>
                  <Button className={styles.groUpComingButton}>
                    View details
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default GroceryShopping;
